import { Link } from "react-router";
import { useGetIdentity } from "ra-core";
import { Settings, User } from "lucide-react";
import { RefreshButton } from "@/components/admin/refresh-button";
import { ThemeModeToggle } from "@/components/admin/theme-mode-toggle";
import { UserMenu } from "@/components/admin/user-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { GlobalSearch } from "./GlobalSearch";
import type { Sale } from "../providers/fakerest/dataGenerator/types";

const Header = () => {
  const { data: identity } = useGetIdentity();
  const user = identity as Sale | undefined;

  return (
    <header className="bg-background border-b border-border h-16 flex items-center px-6 shrink-0">
      <div className="flex items-center justify-between w-full gap-4">
        {/* Spacer for layout balance */}
        <div className="w-[200px]" />

        {/* Global Search */}
        <GlobalSearch />

        {/* Right Actions */}
        <div className="flex items-center gap-1">
          {/* Subtle utility buttons */}
          <div className="flex items-center opacity-60 hover:opacity-100 transition-opacity">
            <ThemeModeToggle />
            <RefreshButton />
          </div>

          {/* Separator */}
          <div className="h-6 w-px bg-border mx-2 hidden md:block" />

          {/* User info and menu */}
          <div className="flex items-center gap-3">
            {/* User email display */}
            <div className="hidden md:flex flex-col items-end">
              <span className="text-sm font-medium">
                {user?.first_name} {user?.last_name}
              </span>
              <span className="text-xs text-muted-foreground">
                {user?.email}
              </span>
            </div>

            {/* User menu with avatar */}
            <UserMenu>
              <DropdownMenuItem asChild className="cursor-pointer">
                <Link to="/profile">
                  <User className="mr-2 h-4 w-4" />
                  Profile
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild className="cursor-pointer">
                <Link to="/settings">
                  <Settings className="mr-2 h-4 w-4" />
                  Settings
                </Link>
              </DropdownMenuItem>
            </UserMenu>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
